import { render, staticRenderFns } from "./BusquedaRapida.vue?vue&type=template&id=65a250f2"
import script from "./BusquedaRapida.vue?vue&type=script&lang=js"
export * from "./BusquedaRapida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports